"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint @typescript-eslint/no-explicit-any: 0 */
var DataMessage = /*#__PURE__*/function () {
  function DataMessage(timestampMs, topic, data, senderAttendeeId, senderExternalUserId, throttled) {
    _classCallCheck(this, DataMessage);
    this.timestampMs = timestampMs;
    this.topic = topic;
    this.data = data;
    this.senderAttendeeId = senderAttendeeId;
    this.senderExternalUserId = senderExternalUserId;
    this.throttled = !!throttled;
  }
  /**
   * Helper conversion methods to convert {@link Uint8Array} data to string
   */
  _createClass(DataMessage, [{
    key: "text",
    value: function text() {
      return new TextDecoder().decode(this.data);
    }
    /**
     * Helper conversion methods to convert {@link Uint8Array} data to JSON
     */
  }, {
    key: "json",
    value: function json() {
      return JSON.parse(new TextDecoder().decode(this.data));
    }
  }]);
  return DataMessage;
}();
exports.default = DataMessage;